import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import signalRMiddleware from './signalrMiddleware'
import userReducer from '../slice/mainslice'

export const store = configureStore({
  reducer: {
    user: userReducer ,
    },
    middleware: [...getDefaultMiddleware(), signalRMiddleware],
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch